<template>
  <div>
       <span class="pull-right">{{$t('notifications.plant')}} Basic
        <i class="fa fa-1x fa-question-circle ml-1 mb-1" style="color:#0090CD" :content="$t('settings.infoPro')" v-tippy="{ placement : 'bottom',  arrow: true }"/>
        <b-button class="typo-butt-add ml-1 mr-1 but-pro"  @click="passaAPro">
            {{$t("settings.activePro")}}
        </b-button>
      </span>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "BannerPro",
  data() {
    return {
    };
  },
  methods: {
      passaAPro() {
             this.$router.push({
                name: "GeneraliImpianto",
                params: { plantId: this.$store.state.currentPlant.id }
            });
      }
  }
};
</script>
